<template>
  <select
    class="form-control form-select"
    :id="id"
    :name="name"
    :disabled="disabled"
    :required="required"
    :value="modelValue || ''"
    @change="$emit('update:modelValue', $event.target.value)"
  >
    <option value="" disabled hidden>{{ placeholder }}</option>
    <option v-for="opt in options" :key="opt" :value="opt">{{ opt }}</option>
  </select>
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  }
})

defineEmits(['update:modelValue'])
</script>
